import { ChildProps } from '@/common/util/props'

interface Props extends ChildProps {
  noMargin?: boolean
}
const SimpleTable = ({ children, noMargin }: Props) => {
  return (
    <div className={`border-primary overflow-hidden rounded-xl border ${noMargin ? '' : 'mt-3'}`}>
      <table className='w-full'>{children}</table>
    </div>
  )
}

export default SimpleTable
